import React from "react";

import styled from "@mui/material/styles/styled";

import Stack, { StackProps } from "@rui/Stack";
import { Img } from "@rui/styles";

type IntegrationProviderIconProps = StackProps & { src: string };

const IntegrationProviderIcon = styled<React.FC<IntegrationProviderIconProps>>(
  ({ src, ...props }) => (
    <Stack variant="center" {...props}>
      <Img className="icon__img" src={src} />
    </Stack>
  )
)(({ theme }) => ({
  border: "1px solid",
  padding: theme.spacing(1),
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: "6px",
  backgroundColor: "#FFF",
  height: "fit-content",
  "& .icon__img": {
    height: "24px",
    width: "24px",
  },
}));

export default IntegrationProviderIcon;
